<template>
    <div id="cities-edit-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1 class="page-title">Edit City</h1>
                <template v-if="loaded">
                    <CitiesForm :formData="formData" submitText="Update" @formSubmitted="formSubmitted" />
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import CitiesForm from '@/components/forms/CitiesForm.vue'

const endpoint = process.env.VUE_APP_API_BASE + 'admin/cities'

import { mapStores } from 'pinia'
import { useMiscStore } from '@/stores/misc.js';

export default {
    name: 'CitiesEdit',
    components: {
        CitiesForm
    },
    data: function() {
        return {
            cityId: '',
            loaded: false
        }
    },
    computed: {
        ...mapStores(useMiscStore)
    },
    created() {
        this.cityId = this.$route.params.id
        this.axios.get(endpoint + '/' + this.cityId)
            .then(response => {
                this.formData = response.data
                this.loaded = true
            }).catch(error => {
                alert('Error occurred')
                console.log(error)
            })

    },
    methods: {
        formSubmitted(finalData) {
            this.axios.post(endpoint + '/' + this.cityId + '/update', finalData)
                .then(response => {
                    if (response.data.result == 'success') {
                        this.miscStore.refreshData()
                        alert('success')
                        this.$router.push('/cities')
                    }
                    else {
                        alert(response.data.message)
                    }
                }).catch(error => {
                    alert('Error occurred')
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
